import React from 'react';
import {
    WORKOUT_REPS_MODE_OPTIONS,
    isNormalRepsExercise,
    normalizeWorkoutRepsMode,
} from '../../../constants/workoutRepsMode';

/**
 * WEBAPP-15: input ripetizioni (fisso / range / a cedimento) - solo esercizi normali.
 */
export default function WorkoutRepsInputs({ exercise, onUpdate }) {
    const isCardio = exercise.is_cardio === 1;
    const isIsometricScheda = exercise.is_isometric_scheda === 1;

    if (isCardio) {
        return (
            <div>
                <label className="mb-1 block text-sm font-medium text-[#3a3a3a] dark:text-white/85">Minuti</label>
                <input
                    type="number"
                    min="1"
                    value={exercise.ripetizioni ?? ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onUpdate(exercise.id, 'ripetizioni', value === '' ? '' : parseInt(value, 10) || '');
                    }}
                    onBlur={(e) => {
                        if (e.target.value === '' || e.target.value === '0') {
                            onUpdate(exercise.id, 'ripetizioni', 20);
                        }
                    }}
                    className="w-full rounded-md border border-[#dad8e5] bg-white px-3 py-2 text-[#3a3a3a] focus:border-[#372d83] focus:ring-2 focus:ring-[#372d83]/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                    placeholder="Minuti (es. 30)"
                />
            </div>
        );
    }

    if (isIsometricScheda) {
        return (
            <div>
                <label className="mb-1 block text-sm font-medium text-[#3a3a3a] dark:text-white/85">Secondi</label>
                <input
                    type="number"
                    min="1"
                    value={exercise.ripetizioni ?? ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onUpdate(exercise.id, 'ripetizioni', value === '' ? '' : parseInt(value, 10) || '');
                    }}
                    onBlur={(e) => {
                        if (e.target.value === '' || e.target.value === '0') {
                            onUpdate(exercise.id, 'ripetizioni', 60);
                        }
                    }}
                    className="w-full rounded-md border border-[#dad8e5] bg-white px-3 py-2 text-[#3a3a3a] focus:border-[#372d83] focus:ring-2 focus:ring-[#372d83]/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                    placeholder="Secondi di tenuta"
                />
            </div>
        );
    }

    const repsMode = normalizeWorkoutRepsMode(exercise.reps_mode);

    const handleModeChange = (mode) => {
        onUpdate(exercise.id, 'reps_mode', mode);
        if (mode === 'fixed') {
            onUpdate(exercise.id, 'ripetizioni_min', null);
            onUpdate(exercise.id, 'ripetizioni_max', null);
            if (!exercise.ripetizioni) {
                onUpdate(exercise.id, 'ripetizioni', 12);
            }
        } else if (mode === 'range') {
            onUpdate(exercise.id, 'ripetizioni_min', exercise.ripetizioni_min ?? 8);
            onUpdate(exercise.id, 'ripetizioni_max', exercise.ripetizioni_max ?? 12);
        } else if (mode === 'amrap') {
            onUpdate(exercise.id, 'ripetizioni_min', null);
            onUpdate(exercise.id, 'ripetizioni_max', null);
            onUpdate(exercise.id, 'ripetizioni', 0);
        }
    };

    return (
        <div className="space-y-2">
            <label className="mb-1 block text-sm font-medium text-[#3a3a3a] dark:text-white/85">Ripetizioni</label>
            <select
                value={repsMode}
                onChange={(e) => handleModeChange(e.target.value)}
                className="mb-2 w-full rounded-md border border-[#dad8e5] bg-white px-3 py-2 text-sm text-[#3a3a3a] focus:border-[#372d83] focus:ring-2 focus:ring-[#372d83]/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            >
                {WORKOUT_REPS_MODE_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
            </select>

            {repsMode === 'fixed' && (
                <input
                    type="number"
                    min="1"
                    value={exercise.ripetizioni ?? ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onUpdate(exercise.id, 'ripetizioni', value === '' ? '' : parseInt(value, 10) || '');
                    }}
                    onBlur={(e) => {
                        if (e.target.value === '' || e.target.value === '0') {
                            onUpdate(exercise.id, 'ripetizioni', 12);
                        }
                    }}
                    className="w-full rounded-md border border-[#dad8e5] bg-white px-3 py-2 text-[#3a3a3a] focus:border-[#372d83] focus:ring-2 focus:ring-[#372d83]/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                    placeholder="Numero ripetizioni"
                />
            )}

            {repsMode === 'range' && (
                <div className="grid grid-cols-2 gap-2">
                    <div>
                        <label className="mb-1 block text-xs text-[#3a3a3a]/70 dark:text-white/60">Min</label>
                        <input
                            type="number"
                            min="1"
                            value={exercise.ripetizioni_min ?? ''}
                            onChange={(e) => onUpdate(exercise.id, 'ripetizioni_min', parseInt(e.target.value, 10) || '')}
                            className="w-full rounded-md border border-[#dad8e5] bg-white px-3 py-2 text-[#3a3a3a] dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                        />
                    </div>
                    <div>
                        <label className="mb-1 block text-xs text-[#3a3a3a]/70 dark:text-white/60">Max</label>
                        <input
                            type="number"
                            min="1"
                            value={exercise.ripetizioni_max ?? ''}
                            onChange={(e) => onUpdate(exercise.id, 'ripetizioni_max', parseInt(e.target.value, 10) || '')}
                            className="w-full rounded-md border border-[#dad8e5] bg-white px-3 py-2 text-[#3a3a3a] dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                        />
                    </div>
                </div>
            )}

            {repsMode === 'amrap' && (
                <p className="text-sm text-[#3a3a3a]/75 dark:text-white/70 italic">
                    Esecuzione a cedimento (nessun target numerico fisso).
                </p>
            )}
        </div>
    );
}

export { isNormalRepsExercise };
